/** @format */
import { css } from 'styled-components';

import {
    NavigationButtonDirection,
    StyledNavigationButtonProps,
} from './types';

const baseStyles = ({ direction }: StyledNavigationButtonProps) => {
    switch (direction) {
        case NavigationButtonDirection.UP:
            return css`
                transform: rotate(-90deg);
            `;
        case NavigationButtonDirection.DOWN:
            return css`
                transform: rotate(90deg);
            `;
        case NavigationButtonDirection.LEFT:
            return css`
                transform: rotate(180deg);
            `;
        case NavigationButtonDirection.RIGHT:
        default:
            return;
    }
};

export const styles = (props: StyledNavigationButtonProps) => css`
    ${baseStyles(props)}
`;
